const border = 'rgba(var(--Mgray-darker),1)'
const connectedColor = 'rgba(var(--Mgreen),1)'
const disabled = 'rgba(var(--Mgray),1)'
const errorColor = 'rgba(var(--Mred),1)'
const fancyColor = 'rgba(var(--Mred),1)'
const fontColor = 'rgba(var(--Mtext),1)'
const fontColor2 = 'rgba(var(--Mtxt),1)'
const headerHeight = '72px'
const lg = '24px'
const marginButtonImg = '12px'
const md = '16px'

const primary = 'rgba(var(--Mprimary),1)'
const primaryLite = 'rgba(var(--Mprimary-lighter),1)'
const primaryActive = 'rgba(var(--Mprimary-darkest),1)'
const secondary = 'rgba(var(--Mprimary),1)'
const secondaryTextOrSvg = 'rgba(var(--Mtext),1)'
const secondaryBackground = 'rgba(var(--Mprimary-darkest),1)'

const sm = '8px'
const warningColor = 'rgba(var(--Myellow),1)'
const alertWarningColor = 'rgba(var(--Myellow),1)'
const infoColor = 'rgba(var(--Mblue),1)'
const xl = '32px'
const xs = '4px'
const xxl = '40px'

module.exports = {
  white: 'rgba(var(--Mwhite),1)',
  light: 'rgba(var(--Mlight),1)',
  dark: 'rgba(var(--Mdark),1)',
  background: 'rgba(var(--Mgray),1)',
  black300: 'rgba(var(--Mtext-lightest),1)',
  black400: 'rgba(var(--Mtext-lighter),1)',
  black500: 'rgba(var(--Mtext),1)',
  black600: 'rgba(var(--Mtext-darker),1)',
  boldFont: 700,
  bolderFont: 500,
  border,
  buttonLargeFontSize: '16px',
  connected: connectedColor,
  disabled,
  error: errorColor,
  extraBoldFont: 800,
  extraLargeFontSize: '20px',
  extraSmallFontSize: '11px',
  fancy: fancyColor,
  fontColor,
  fontColor2,
  fontSizeHeadingLg: 32,
  fontSizeHeadingMd: 20,
  fontSizeHeadingSm: 16,
  fontSizeHeadingXs: 13,
  grey400: 'rgba(var(--Mgray-lightest),1)',
  gray500: 'rgba(var(--Mgray-lighter),1)',
  green200: 'rgba(var(--Mgray),1)',
  green500: 'rgba(var(--Mgray-darker),1)',
  headerHeight,
  largeFontSize: '16px',
  lg,
  lightFont: 300,
  mainFontFamily: "'Montserrat', sans-serif",
  marginButtonImg,
  md,
  mediumFontSize: '14px',
  orange500: '#e8663d',
  orange200: '#FFF4E3',
  primary,
  primaryLite,
  primaryActive,
  primary200: primaryLite,
  primary300: 'rgba(var(--Mprimary),1)',
  primary400: primaryActive,
  infoColor,
  regularFont: 400,
  red400: 'rgba(var(--Mred),1)',
  screenLg: 1200,
  screenMd: 992,
  screenMdMax: 1199,
  screenSm: 768,
  screenSmMax: 991,
  screenXs: 480,
  screenXsMax: 767,
  secondary,
  secondaryFontFamily: "'Montserrat', sans-serif",
  secondaryText: secondaryTextOrSvg,
  secondaryBackground,
  sm,
  smallFontSize: '12px',
  warning: warningColor,
  alertWarning: alertWarningColor,
  xl,
  xs,
  xxl,
  xxlFontSize: '32px',
}
